// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"PEJG8gT1bZkrdVxZanUED","companyLogo":"K8uzb06ytqqLUU_vB-WX6","logoImg":"_2xVYMQBKQDVoG3NNgg03O3","communityStamp":"_1x-Lg_rLdXtzh-zXpHkymz","associationStamp":"_3G5GooJ1j4J8psw6WCam2k","purpleStamp":"_3Z-xPJyTKgfFmYJ0cXQR9i","withBroker":"FKaj1CXMHDlMj4r-8wsSp","infoBlock":"_2ExqXnUlSVA8FDFCS2BNCh","infoBlock_title":"_3oAR2AZ7ZWysMnYgVX6TK2","withCommunity":"_1yqXgKO3VnsZ2xoKxILwWv","addressBlock":"_3S0Q1vXL2RxkkWhqR2ZzXC","defaultLang":"_20Ih1IVcQlTA9lbCeOqLof"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/AboutStaff/AboutStaff.scss
// module id = 1755
// module chunks = 0